import CarSearchIncoming from './car-search-incoming';

function init() {
  CarSearchIncoming.init();
}

export { init };
